import queryString from 'query-string';
import _ from 'lodash';

export default function changePage(history, location, pageNumber) {
  history.push({
    pathname: location.pathname,
    search: queryString.stringify(_.extend({}, queryString.parse(location.search), {
      page: pageNumber
    }))
  });
}
